import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

export interface AdminReferralParams {
  limit?: number;
  skip?: number;
  search?: string;
}

export const useAdminReferrals = (params?: AdminReferralParams) =>
  useQuery({
    queryKey: ['admin-referrals', params],
    queryFn: () => apiService.getAdminReferrals(params),
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    retry: 1,
    // keeps the table stable while a new page/search resolves
    placeholderData: keepPreviousData,
  });

export const useAdminReferralStats = () =>
  useQuery({
    queryKey: ['admin-referral-stats'],
    queryFn: apiService.getAdminReferralStats,
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    retry: 1,
  });
